import ReportTableRowContainer from './ReportTableRowContainer'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

const mapStateToProps = state => {
  return {
    selectedRegionId: state.REGIONS.selectedRegionId,
    selectedRegionCountryMeta: state.REGIONS.selectedRegionCountryMeta,
    regionsData: state.REGIONS.regionsData,
    countriesData: state.REGIONS.countriesData,
    referenceRegionsData: state.REGIONS.referenceRegionsData,
    sameCountryRegionsData: state.REGIONS.sameCountryRegionsData,
    allRegionsGroupRegionId: state.REGIONS.allRegionsGroupRegionId,
    allRegionsFilter: state.FILTERS.allRegionsFilter,
    referenceRegionsFilter: state.FILTERS.referenceRegionsFilter,
    sameCountryRegionsFilter: state.FILTERS.sameCountryRegionsFilter,
    otherRegionsFilter: state.FILTERS.otherRegionsFilter,
    yearsEvolution: state.FILTERS.evolutionFilter,
    indicatorsData: state.INDICATORS.indicatorsData
  }
}

export default withRouter(connect(mapStateToProps)(ReportTableRowContainer))



// WEBPACK FOOTER //
// ./src/modules/Charts/ReportTableRow/ReportTableRowContainer/index.js